import appsetting from "../appsetting";

import * as userUtils from "@/store/userUtils";

//const axios = require("axios").default;
import axios from "axios";

const axiosGet = (url, params = null, headers = null) => {
  return axios.get(url, { params, headers: appKeyToHeaders(headers) });
};

const axiosGetPublic = (url, params = null, headers = null) => {
  return axios.get(url, { params, headers: appKeyPublicToHeaders(headers) });
};

const axiosPost = (url, params = null, headers = null) => {
  return axios.post(url, params, { headers: appKeyToHeaders(headers) });
};

const axiosDelete = (url, params = null, headers = null) => {
  return axios.delete(url, { params, headers: appKeyToHeaders(headers) });
};

const axiosPut = (url, params = null, headers = null) => {
  return axios.put(url, params, { headers: appKeyToHeaders(headers) });
};

const appKeyToHeaders = (headers) => {
  if (headers == null) {
    headers = {};
  }

  headers.ApiKey = appsetting.backendAPI.apiKey;
  headers.Password = appsetting.backendAPI.password;

  // ใช้สำหรับทำแจ้งเตือน ในกรณีที่ไม่สามารถระบุ permission role ได้จาก user ที่มี role มากกว่า 1
  const currentPermission = userUtils.getCurrentPermissionGroupId();
  // console.log("axiosUtils currentPermission", currentPermission);
  if (
    currentPermission !== null &&
    currentPermission !== undefined &&
    currentPermission !== ""
  ) {
    headers.Permission = userUtils.getCurrentPermissionGroupId();
  }

  const currentDepartment = userUtils.getCurrentDepartmentId();
  // console.log("axiosUtils currentDepartment", currentDepartment);
  if (
    currentDepartment !== null &&
    currentDepartment !== undefined &&
    currentDepartment !== ""
  ) {
    headers.Department = userUtils.getCurrentDepartmentId();
  }

  // now try to add token
  headers.Authorization = userUtils.getCurrentToken();

  return headers;
};

const appKeyPublicToHeaders = (headers) => {
  if (headers == null) {
    headers = {};
  }

  headers.ApiKeyPublic = appsetting.backendAPI.apiKeyPublic;
  headers.PasswordPublic = appsetting.backendAPI.passwordPublic;

  return headers;
};

/**
 * ดาวน์โหลดไฟล์จาก API แบบ POST
 *
 * คืน Promise ออกไปด้วย เพื่อให้ผู้เรียก await และ try/catch ได้จริง
 * (ก่อนหน้านี้ไม่คืนและไม่มี .catch — error จึงเงียบ และผู้ใช้ได้ไฟล์เสียโดยไม่มีอะไรแจ้ง)
 */
const axiosDownloadFilePost = (
  url,
  filename = "export",
  extension = ".pdf",
  params = null,
  headers = null
) => {
  return axios({
    url: url,
    method: "POST",
    headers: headers,
    data: params,
    responseType: "blob", // important
  })
    .then((response) => {
      const contentType =
        (response.headers && response.headers["content-type"]) || "";

      // ตอบกลับมาเป็น JSON = เป็นข้อความ error หรือ ExportModel ที่ set Base64 ไว้
      // ไม่ใช่ตัวไฟล์ ถ้าปล่อยผ่านผู้ใช้จะได้ .xlsx ที่ข้างในเป็น JSON
      if (contentType.indexOf("application/json") >= 0) {
        throw new Error("เซิร์ฟเวอร์ตอบกลับเป็น JSON ไม่ใช่ไฟล์");
      }
      // ไฟล์ 0 byte = ฝั่ง server ยังไม่มี branch ของรายงานนั้น หรือชื่อรายงานผิด
      if (!response.data || response.data.size === 0) {
        throw new Error("ไฟล์ที่ได้จากเซิร์ฟเวอร์ว่างเปล่า (0 byte)");
      }

      const aurl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = aurl;
      link.setAttribute("download", filename + extension);
      document.body.appendChild(link);
      link.click();
      // เก็บกวาดหลังสั่งดาวน์โหลด ไม่งั้น blob จะค้างในหน่วยความจำจนกว่าจะปิดแท็บ
      link.remove();
      window.URL.revokeObjectURL(aurl);
    })
    .catch((error) => {
      console.log("axiosDownloadFilePost error", error);
      // โยนต่อให้ผู้เรียกตัดสินใจว่าจะแจ้งผู้ใช้อย่างไร
      throw error;
    });
};

const axiosDownloadFileGet = (
  url,
  filename = "export",
  extension = ".pdf",
  params = null,
  headers = null
) => {
  //return axios.post(url, params, { headers: appKeyToHeaders(headers) });
  axios({
    url: url,
    method: "Get",
    headers: headers,
    data: params,
    responseType: "blob", // important
  }).then((response) => {
    const aurl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = aurl;
    link.setAttribute("download", filename + extension);
    document.body.appendChild(link);
    link.click();
  });
};
export {
  appKeyToHeaders,
  axiosGet,
  axiosPost,
  axiosDelete,
  axiosPut,
  axiosDownloadFilePost,
  axiosDownloadFileGet,
  axiosGetPublic,
};
